export default __webpack_public_path__ + "static/media/hero.3aabac99.svg";